// For now, a simple array. In the future, this could be fetched from an API.
export const EVENTS = [
  {
    id: 'boston-marathon-2026',
    title: 'Boston Marathon 2026',
    datetime: '2026-03-31T10:00:00', // ISO 8601 format with time
    location: 'Boston, MA',
    address: 'Hopkinton, MA 01748',
    icon: 'event', // References the PNG filename (without .png)
    coordinates: [-71.5226, 42.2287] // [longitude, latitude] - Hopkinton start line
  }
]
